module.exports = __webpack_public_path__ + "img/appSence.df4dfce.png";